export type OfferActionId =

  | 'offer-create'

  | 'offer-edit-menu' | 'offer-update' | 'offer-regenerate'



/** UI event actions declared by the client — never backend intent names. */

export type OfferUiEventAction =

  | 'offer.edit_content'

  | 'offer.regenerate'

  | 'offer.create'



export interface OfferQuickAction {

  id: OfferActionId

  label: string

  prompt: string

  /** @deprecated Prefer uiEvent — kept for transitional typing only. */

  intentHint?: string

  uiEvent?: { type: 'quick_action'; action: OfferUiEventAction }

  selection: 'none' | 'single'

  requiresCandidate?: boolean

  destructive?: boolean

  disabled?: boolean

  tooltip?: string

}



interface Context {

  offerCount: number

  offerStatus?: string

  t: (key: string) => string

  allowedActions?: string[]

  canViewOffers?: boolean

  canCreateOffers?: boolean

  canEditOffers?: boolean

}



const UI_EVENT_BY_ACTION_ID: Partial<Record<OfferActionId, OfferUiEventAction>> = {

  'offer-update': 'offer.edit_content',

  'offer-regenerate': 'offer.regenerate',

  'offer-create': 'offer.create',

}



export const getPrimaryOfferQuickActions = ({

  t,

  canViewOffers = true,

  canCreateOffers = true,

  canEditOffers = true,

}: Context): OfferQuickAction[] => {

  return [

    ...(canCreateOffers ? [{

      id: 'offer-create' as const,

      label: t('offers.createOffer'),

      prompt: t('aiAssistant.offerActions.prompts.create'),

      uiEvent: { type: 'quick_action' as const, action: 'offer.create' as const },

      selection: 'none' as const,

    }] : []),

    ...(canViewOffers && canEditOffers ? [{ id: 'offer-edit-menu' as const, label: t('aiAssistant.offerActions.manage'), prompt: '', selection: 'single' as const }] : []),

  ]

}



export const getOfferEditQuickActions = ({

  offerCount,

  t,

  allowedActions,

}: Context): OfferQuickAction[] => {

  const hasSelectedOffer = offerCount === 1

  const allowed = new Set(hasSelectedOffer ? (allowedActions ?? []) : [])



  const build = (

    id: OfferActionId,

    label: string,

    prompt: string,

    extra?: Partial<OfferQuickAction>,

  ): OfferQuickAction => ({

    id,

    label,

    prompt,

    uiEvent: {

      type: 'quick_action',

      action: UI_EVENT_BY_ACTION_ID[id] as OfferUiEventAction,

    },

    selection: 'single',

    ...extra,

  })



  return [

    ...(allowed.has('offer_update') ? [build('offer-update', t('aiAssistant.offerActions.editContent'), t('aiAssistant.offerActions.prompts.update'))] : []),

    ...(allowed.has('offer_regenerate') ? [build('offer-regenerate', t('aiAssistant.offerActions.regenerate'), t('aiAssistant.offerActions.prompts.regenerate'))] : []),

  ]

}


